import { defineStore } from "pinia"
import { Subject } from "rxjs"
import { ContextMenuItem } from "src/util/classes/contextMenuItem"
import { ContextAction, MainMenuType } from "src/util/enums/entityType"
import { NavigationAction } from "src/util/enums/topNavigation"
import { Breadcrumbs } from "src/util/types/components/sfxBreadcrumb"
import { MenuDataNames } from "src/util/types/dataModels/entityDefinition"

export interface ManagerTopNavigationStore {
  title: string
  titleReference?: string | null
  titleClass?: string
  titleReferenceClass?: string
  mainMenuContent?: MainMenuType[]
  disableMainMenuContent: MainMenuType[]
  hideExtendedMenu: boolean
  disableExtendedMenu: boolean
  quickActions?: ContextAction[]
  disableQuickActions?: ContextAction[]
  contextMenuContent: ContextAction[]
  disableContextMenuContent: ContextAction[]
  disableContextMenu: boolean
  hideContextMenu: boolean
  hideContextBar: boolean
  disableNotifications: boolean
  hideTodoIcon: boolean
  disableTodoIcon: boolean
  contextActionClicked: Subject<ContextMenuItem>
  breadcrumbs?: Breadcrumbs
  breadcrumbsContext?: string
  breadcrumbsNavigationAction?: NavigationAction
  activeTab?: MenuDataNames
  activeExtendedTab?: MenuDataNames
}

export const useManagerTopNavigationStore = defineStore("pinia-managerTopNavigationStore", {
  persist: false,

  state: (): ManagerTopNavigationStore => ({
    title: "",
    titleReference: undefined,
    titleClass: undefined,
    titleReferenceClass: undefined,
    mainMenuContent: undefined,
    disableMainMenuContent: [],
    hideExtendedMenu: false,
    disableExtendedMenu: false,
    quickActions: [],
    disableQuickActions: [],
    contextMenuContent: [],
    disableContextMenuContent: [],
    disableContextMenu: false,
    hideContextMenu: false,
    hideContextBar: false,
    disableNotifications: false,
    hideTodoIcon: false,
    disableTodoIcon: false,
    contextActionClicked: new Subject(),
    breadcrumbs: [],
    breadcrumbsContext: undefined,
    breadcrumbsNavigationAction: undefined,
    activeTab: undefined,
    activeExtendedTab: undefined,
  }),

  actions: {
    setContextAction(item: ContextMenuItem) {
      this.contextActionClicked.next(item)
    },
  },
})
